import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Router, NavigationExtras, RouterLink as RouterLink_1 } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';

import { resolveStringCellValue } from '../../utils/resolved-concatenated-value';

interface RouterLink {
	routerLink(value: string, index: number, params: ICellRendererParams<unknown, unknown>): LinkConfig | undefined;
}

interface ValueRouterLinkParams {
	value: string;
	routerLinkParams: LinkConfig | undefined;
}
interface LinkConfig {
	commands: unknown[];
	extras?: NavigationExtras;
}

@Component({
	selector: 'copo-link-multi-value-cell',
	templateUrl: './link-multi-value-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, NgFor, RouterLink_1]
})
export class LinkMultiValueCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	params?: ICellRendererParams<unknown, unknown>;
	routerLinkParams?: LinkConfig;
	values?: ValueRouterLinkParams[] = [];
	constructor(
		readonly changeDetectorRef: ChangeDetectorRef,
		readonly router: Router,
	) {}

	agInit(params: ICellRendererParams<unknown, unknown>) {
		this.params = params;
		if (!this.params.colDef) {
			return;
		}
		const routerLinkParams = <RouterLink> this.params.colDef.cellRendererParams;
		if (this.params.value) {
			this.values = resolveStringCellValue(<string> this.params.value).map(
				(value, index) => ({
					value,
					routerLinkParams: routerLinkParams.routerLink(value, index, params)
				})
			);
		}
		this.changeDetectorRef.markForCheck();
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		this.params = params;
		if (!this.params.colDef) {
			return false;
		}
		const routerLinkParams = <RouterLink> this.params.colDef.cellRendererParams;
		if (this.params.value) {
			this.values = resolveStringCellValue(<string> this.params.value).map(
				(value, index) => ({
					value,
					routerLinkParams: routerLinkParams.routerLink(value, index, params)
				})
			);
		}
		this.changeDetectorRef.markForCheck();
		return true;
	}
}
